// config/faq.ts
// Centralizovaná FAQ data pro Q&A stránku

/**
 * FAQ položka pro Q&A stránku
 */
export interface FAQItem {
  /** Unikátní identifikátor otázky */
  key: string;
  /** Text otázky */
  question: string;
  /** Text odpovědi (může obsahovat HTML) */
  answer: string;
  /** Zda se má otázka zobrazit v seznamu (default: true) */
  inList?: boolean;
}

export const FAQ_ITEMS: readonly FAQItem[] = [
  {
    key: '1',
    question: 'Co je to Vstupní cenové navýšení (VCN)?',
    answer: 'VCN je vratná rezervační záloha, kterou klient složí při nákupu slitku nebo mince a která se mu vrací při zpětném výkupu jako Výkupní prémie iiplan součástí výkupní ceny slitku nebo mince.\n\n\n• iiplanGold®: vrací se v maximální výši při zpětném výkupu každého 1 kg slitku PAMP po 5 letech od dodání\n\n\n• iiplanGold®: vrací se postupně při výběru z Váhového konta v kovu a při převodu gramů na jinou smlouvu iiplanGold®\n\n\n• iiplanGold®: nevrací se při zpětném výkupu 1 kg slitku PAMP do 5 let od dodání\n\n\n• iiplanGold®: nevrací se při výběru z Váhového konta v penězích ani při převodu gramů na iiplanRentier® či iiplanMax®\n\n\n• iiplanRentier®: vrací se v celé zaplacené výši při zpětném výkupu prvního 10 oz slitku PAMP\n\n\n• iiplanRentier®: vrací se postupně při výběru v kovu a při převodu gramů na jinou smlouvu iiplanRentier®\n\n\n• iiplanRentier®: nevrací se při výběru v penězích ani při převodu gramů na iiplanGold® či iiplanMax®\n\n\n• iiplanMax®: vrací se v celé zaplacené výši při zpětném výkupu prvního 400 oz slitku PAMP\n\n\n• iiplanMax®: vrací se postupně při výběru v kovu a při převodu gramů na jinou smlouvu iiplanMax®\n\n\n• iiplanMax®: nevrací se při výběru v penězích ani při převodu gramů na iiplanGold® či iiplanRentier®'
  },
  {
    key: '2',
    question: 'Co je to typ smlouvy?',
    answer: 'Typ smlouvy určuje, jak je platba klienta do doby úplného uhrazení VCN rozdělena mezi úhradu VCN (první číslo v %) a nákup kovu (druhé číslo za lomítkem).\n\n\n• iiplanGold® a iiplanRentier®: varianty 70/30 (29 000 CZK; se slevou 30 % = 20 300 CZK) a 100/0 (19 000 CZK)\n\n\n• iiplanMax®: varianta 100/0 (39 000 CZK; se slevou 30 % = 27 300 CZK)'
  },
  {
    key: '3',
    question: 'Co je to spread?',
    answer: 'Spread je rozdíl mezi nákupní (vyšší) a výkupní (nižší) cenou slitku nebo mince.\n\n\n• Cena zlata musí vzrůst o hodnotu spreadu, aby klient začal být v zisku\n\n\n• Čím je spread nižší, tím je pro klienta výhodnější\n\n\n• Nejvyšší spread je u nejnižších gramáží (např. 1 g); nejnižší u nejvyšších (např. 1 kg)\n\n\n• Vyšší spread prodlužuje dobu, než se investice stane ziskovou'
  },
  {
    key: '4',
    question: 'Jaké jsou náklady u smlouvy iiplanGold®?',
    answer: '• Vstupní cenové navýšení: vratná záloha při dospoření a zpětném výkupu nejdříve po 5 letech u všech 1 kg slitků; průběžný návrat při výplatě v kovu a převodu gramů na jinou smlouvu iiplanGold®; dvě varianty 70/30 (29 000 CZK; se slevou 30 % = 20 300 CZK) a 100/0 (19 000 CZK), hrazeno jednorázově po sjednání smlouvy.\n\n\n• Management Fee: 0,9125 % ročně z části Váhového konta do 500 g; nad 500 g se neúčtuje\n\n\n• Success Fee: 10 % z hodnoty výnosu. Počítá se pouze ze zhodnocení nad 4 % a vztahuje se na konkrétní částku při jejím výběru, nebo převodu\n\n\n• Spread: rozdíl mezi nákupní a výkupní cenou 1 kg slitku i jednotlivých gramů ve výši 4 %.'
  },
  {
    key: '5',
    question: 'Jaké jsou náklady u smlouvy iiplanRentier®?',
    answer: '• Vstupní cenové navýšení: vratná záloha v zaplacené výši při dospoření a zpětném výkupu prvního 311 g slitku; průběžný návrat při výplatě v kovu a převodu gramů na jinou smlouvu iiplanRentier®; dvě varianty 70/30 (29 000 CZK; se slevou 30 % = 20 300 CZK) a 100/0 (19 000 CZK), hrazeno jednorázově po sjednání smlouvy.\n\n\n• Spread: rozdíl mezi nákupní a výkupní cenou 311 g slitku ve výši cca 8 % a u jednotlivých gramů cca 9 %'
  },
  {
    key: '6',
    question: 'Jaké jsou poplatky u smlouvy iiplanMax®?',
    answer: '• Vstupní cenové navýšení: vratná záloha v zaplacené výši při dospoření a zpětném výkupu prvního 400 oz slitku; průběžný návrat při výplatě v kovu a převodu gramů na jinou smlouvu iiplanMax®; varianta 100/0 (39 000 CZK; se slevou 30 % = 27 300 CZK), hrazeno jednorázově po sjednání smlouvy.\n\n\n• Success Fee: 15 % z hodnoty výnosu. Počítá se pouze ze zhodnocení nad 3 % a vztahuje se jen na konkrétní částku při jejím výběru, nebo převodu.\n\n\n• Spread: rozdíl mezi nákupní a výkupní cenou 400 oz slitku i jednotlivých gramů ve výši 3 %'
  },
  {
    key: '7',
    question: 'Co když zkrachuje FireGOLD?',
    answer: '• Pokud by FireGOLD zkrachovala, klientů se to nijak nedotkne, protože smluvním partnerem je IBIS InGold, která garantuje dodání zlata, plnění smluvních podmínek a zpětný výkup.'
  },
  {
    key: '8',
    question: 'Co když zkrachuje IBIS InGold?',
    answer: '• V případě úpadku IBIS InGold budou klienti uspokojeni z výtěžku konkurzního řízení v penězích.\n\n\n• Konkurs je soudní proces, při němž se zpeněží majetek dlužníka a výtěžek se rozdělí mezi věřitele.\n\n\n• IBIS InGold působí na trhu 27 let, je autorizovaným partnerem PAMP a The Royal Mint, má miliardové obraty, vlastní kapitál ve stovkách milionů a žádné závazky k úvěrovým institucím.'
  },
  {
    key: '9',
    question: 'Co když bude dlouhodobý blackout? Co když nepůjde internet?',
    answer: '• V případě dlouhodobého blackoutu nebo výpadku internetu je nutné majetek diverzifikovat – zlato by mělo tvořit jen část portfolia.\n\n\n• Doporučuje se mít hotovost, zásoby potravin a denních potřeb.\n\n\n• Stát by podnikl opatření k rychlému obnovení dodávek energie a internetu.'
  },
  {
    key: '10',
    question: 'Přijímáte platby v hotovosti?',
    answer: '• Platby v hotovosti nepřijímáme.\n\n\n• Úhrady nákupů a pravidelné platby na spořicí programy lze provést bezhotovostním převodem nebo vkladem hotovosti na bankovní účet IBIS InGold.'
  },
  {
    key: '11',
    question: 'Může mi zlato zabavit exekutor?',
    answer: '• Investice do drahých kovů je anonymní – majitel může zlato prodat či darovat bez povinné evidence, což přináší výhodu při exekuci nebo dědictví, pokud zlato klient drží mimo depozit.'
  },
  {
    key: '12',
    question: 'Co když klient zemře?',
    answer: '• Při úmrtí klienta smlouva vstupuje do dědického řízení.\n\n\n• Zákonný dědic doloží dědický nárok a úmrtní list.'
  },
  {
    key: '13',
    question: 'Co když mi bude zlato ukradeno a budou ho chtít u Vás vykoupit? Vykoupíte ho? Pokud budete mít informaci, že je moje a bylo ukradeno?',
    answer: '• V případě odcizení zlata je třeba situaci nahlásit policii a IBIS InGold.\n\n\n• Pokud se někdo pokusí prodat odcizené zlato, IBIS InGold upozorní policii a zabezpečí jeho vrácení klientovi.'
  },
  {
    key: '14',
    question: 'Proč nemáte pobočky, kde si zlato mohu vyzvednout?',
    answer: '• Kromě provozní centrály v Moravských Budějovicích, kde si po domluvě můžete zlato osobně vyzvednout, nemáme další pobočky.\n\n\n• Standardně zasíláme zlato klientům poštou v pojištěné bezpečnostní obálce.'
  },
  {
    key: '15',
    question: 'Proč je všude IBIS InGold a ne FireGOLD?',
    answer: '• Smluvním partnerem klienta je IBIS InGold, která garantuje dodání zlata, plnění smluvních podmínek a zpětný výkup.\n\n\n• FireGOLD je dceřiná společnost IBIS InGold zajišťující prodej, poradenství a následný servis.'
  },
  {
    key: '16',
    question: 'Může být první platba a další platby klienta z bankovního účtu mimo EU?',
    answer: '• První i další platby musejí být zaslány z bankovního účtu v EU, případně Švýcarska nebo Velké Británie kvůli dodržení AML předpisů.\n\n\n• Tyto jurisdikce mají přísné standardy pro ověřování klientů a kontrolu sankcí.'
  },
  {
    key: '17',
    question: 'Kontakt',
    answer: 'Kontakt pro případné dotazy: <a href=\'mailto:iplan@firegoldgroup.com \'>iplan@firegoldgroup.com</a>' +
      '\n\n\nTelefon: <a href=\'tel:+420736704706\'>+420 736 704 706</a>.' +
      '\n\n\nWeb: <a href=\'https://www.firegoldgroup.com\' target=\'_blank\'>www.firegoldgroup.com</a>.',
    inList: false
  }
] as const;
